import { useAuthenticated } from "../../authn";

export function useReviewerIdentity(): string {
  const auth = useAuthenticated();

  if (auth.state !== "authenticated") {
    return "";
  }

  return auth.user.email ?? auth.user.name ?? auth.userId;
}
